module.exports = __webpack_public_path__ + "public/img/subscription-bg-2-cae135e8.jpg";